import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as constants from '../common/constants';
import * as JspUtil from '../common/JspUtil';
import * as globalActions from '../layout/actionCreators';
import LoginTemplate from '../loginpages/LoginTemplate';
import Box from '@mui/material/Box';
import { PageContainer, PageHeader } from '../components';
import { useJspVariables, useAppContext, useAuth, useDebugRender } from '../hooks';

const PageWebLogin = () => {
    useDebugRender('PageWebLogin');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { panelStyle, jspVariables } = useJspVariables();
    const { getLoginApp, getLabelFromJspVariables } = useAppContext(jspVariables);

    const { authenticatedUser } = useAuth();
    const appUiMessages = useSelector(state => state.globalReducer.appUiMessages);
    const appKey = jspVariables.jspLoginApp || getLoginApp() || '';

    const [relogin, setRelogin] = useState(false);

    useEffect(() => {
        if (appKey) {
            dispatch(globalActions.getAppUiMessages(appKey));
        } else if (getLoginApp()) {
            dispatch(globalActions.getAppUiMessages(getLoginApp()));
        }

        if (getLoginApp() == 'LAUNCHER') {
            dispatch(globalActions.getAppUiMessages(getLoginApp()));
        }

        if (authenticatedUser && authenticatedUser.user) {
            navigate(constants.ROUTE_PAGE_AUTHENTICATED);
        }

        if (JspUtil.isValueAvailable(window.jspReloginUserId)) {
            setRelogin(true);
        }
    }, []);

    const getUiMsg = (key) => {
        if (appUiMessages) {
            let msg = null;
            appUiMessages.forEach(m => {
                if (m.uiPlaceHolder == key) {
                    msg = m.message;
                }
            });
            if (msg != null) {
                return msg;
            }
        }
        return '';
    };

    const loginHeader = getUiMsg(constants.LOGIN_APP_HEADER);

    return (
        <PageContainer id="pageWebLogin" dataAutomationId="page_web_login">
            <Box style={panelStyle}>
                <PageHeader dataAutomationId="web_login_header">
                    {loginHeader ?
                        <Box dangerouslySetInnerHTML={{ __html: loginHeader }} />
                        :
                        getLabelFromJspVariables('title_sso_login')
                    }
                </PageHeader>
                <Box>
                    <LoginTemplate />
                </Box>
            </Box>
        </PageContainer>
    );
};

export default PageWebLogin;
